"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_OperationDefinition_Binding = exports.OperationDefinition_BindingStrengthKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var OperationDefinition_BindingStrengthKind;
(function (OperationDefinition_BindingStrengthKind) {
    OperationDefinition_BindingStrengthKind["_required"] = "required";
    OperationDefinition_BindingStrengthKind["_extensible"] = "extensible";
    OperationDefinition_BindingStrengthKind["_preferred"] = "preferred";
    OperationDefinition_BindingStrengthKind["_example"] = "example";
})(OperationDefinition_BindingStrengthKind = exports.OperationDefinition_BindingStrengthKind || (exports.OperationDefinition_BindingStrengthKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_OperationDefinition_Binding = t.recursion('IOperationDefinition_Binding', function () {
    return t.intersection([
        t.type({
            valueSet: RTTI_canonical_1.RTTI_canonical
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            strength: (0, EnumType_1.createEnumType)(OperationDefinition_BindingStrengthKind, 'OperationDefinition_BindingStrengthKind'),
            _strength: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_OperationDefinition_Binding.js.map